import {
  GET_LIST_CONVERTER_KIT_TAGS,
  GET_LIST_CONVERTER_KIT_TAGS_SUCCESS,
  GET_LIST_CONVERTER_KIT_TAGS_ERROR,
} from "./actionTypes";

const initialState = {
  data: [],
  error: "",
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CONVERTER_KIT_TAGS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_LIST_CONVERTER_KIT_TAGS_SUCCESS:
      state = {
        ...state,
        data: action.payload.data,
        loading: false,
      };
      break;
    case GET_LIST_CONVERTER_KIT_TAGS_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
